import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { Link } from "react-router-dom";
import {
  EyeOutlined,
  EditOutlined,
  CheckCircleOutlined,
  ArrowUpOutlined,
  ReloadOutlined,
  MoreOutlined,
} from "@ant-design/icons";

/**
 * Returns the hazard actions dropdown column config.
 *
 * @param {object} options
 * @param {boolean} options.canEdit - Whether the user can edit hazards
 * @param {boolean} options.showViewLink - Whether to show "View Details" link (navigates to /hazards/:id)
 * @param {function} options.canEditHazard - Per-row check: (hazard) => boolean
 * @param {object} options.handlers - { handleEditClick, handleResolveClick, handleEscalateClick, handleReopenClick }
 */
export const getHazardActionColumn = ({
  canEdit = true,
  showViewLink = true,
  canEditHazard,
  handlers,
}) => ({
  title: "Actions",
  key: "actions",
  render: (_, record) => {
    const canResolve =
      record.status !== "resolved" && record.status !== "closed";
    const canEscalate =
      record.current_escalation_level < 3 &&
      record.status !== "resolved" &&
      record.status !== "closed";
    const canReopen =
      record.status === "resolved" || record.status === "closed";
    const editAllowed =
      canEdit && (typeof canEditHazard === "function" ? canEditHazard(record) : true);

    return (
      <Dropdown
        overlay={
          <Menu>
            {showViewLink && (
              <Menu.Item key="view" icon={<EyeOutlined />}>
                <Link to={`/hazards/${record.id}`}>View Details</Link>
              </Menu.Item>
            )}
            {editAllowed && (
              <Menu.Item
                key="edit"
                icon={<EditOutlined />}
                onClick={() => handlers.handleEditClick(record)}
              >
                Edit Hazard
              </Menu.Item>
            )}
            {canResolve && (
              <Menu.Item
                key="resolve"
                icon={<CheckCircleOutlined />}
                onClick={() => handlers.handleResolveClick(record)}
              >
                Rectified
              </Menu.Item>
            )}
            {canEscalate && (
              <Menu.Item
                key="escalate"
                icon={<ArrowUpOutlined />}
                onClick={() => handlers.handleEscalateClick(record)}
              >
                Escalate
              </Menu.Item>
            )}
            {canReopen && (
              <Menu.Item
                key="reopen"
                icon={<ReloadOutlined />}
                onClick={() => handlers.handleReopenClick(record)}
              >
                Reopen
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>
    );
  },
  width: 80,
  align: "center",
});
